module.exports = __webpack_public_path__ + "static/assets/2dbfac58a99f6f1bbd66a23a6519ef10.png";